<div class="header">
  <h2>{{ data.address.id ? "Update" : "Add" }} Address Information</h2>
  <i class="pi pi-times" style="font-size: 1.5rem" (click)="closeModal()"></i>
</div>
<p-card class="section">
  <form [formGroup]="addressForm">
    <div class="grid p-fluid">
      <div class="col-12 sm:col-6 md:col-6">
        <h3>Pin Code <span class="required-field">*</span></h3>
        <input
          type="text"
          pInputText
          placeholder="PIN Code"
          formControlName="pin_code"
          maxlength="6"
        />
        <small
          *ngIf="
            addressForm.get('pin_code')?.invalid &&
            addressForm.get('pin_code')?.touched
          "
          class="p-error"
        >
          Please enter a valid 6-digit PIN code
        </small>
        <small *ngIf="pincodeDetailsLoading" class="loading-text"
          >Loading pincode details...</small
        >
      </div>

      <div class="col-12 sm:col-6 md:col-6">
        <h3>City</h3>
        <input
          type="text"
          pInputText
          placeholder="City"
          formControlName="city"
          readonly
        />
      </div>
    </div>

    <div class="grid p-fluid">
      <div class="col-12 sm:col-6 md:col-6">
        <h3>District</h3>
        <input
          type="text"
          pInputText
          placeholder="District"
          formControlName="district"
          readonly
        />
      </div>

      <div class="col-12 sm:col-6 md:col-6">
        <h3>State</h3>
        <input
          type="text"
          pInputText
          placeholder="State"
          formControlName="state"
          readonly
        />
      </div>
    </div>

    <div class="grid p-fluid">
      <div class="col-12 sm:col-6 md:col-6">
        <h3>Country</h3>
        <input
          type="text"
          pInputText
          placeholder="Country"
          formControlName="country"
          readonly
        />
      </div>
    </div>

    <div class="grid p-fluid">
      <div class="col-12">
        <h3>Address <span class="required-field">*</span></h3>
        <textarea
          rows="3"
          pInputTextarea
          placeholder="Address Line"
          formControlName="location"
        ></textarea>
        <small
          *ngIf="
            addressForm.get('location')?.invalid &&
            addressForm.get('location')?.touched
          "
          class="p-error"
        >
          Address is required
        </small>
      </div>
    </div>

    <div class="grid p-fluid">
      <div class="col-12">
        <h3>Landmark</h3>
        <input
          type="text"
          pInputText
          placeholder="Landmark (Optional)"
          formControlName="landmark"
        />
      </div>
    </div>

    <div class="col-12 flex flex-row justify-content-end">
      <p-button
        icon="pi pi-times"
        label="Cancel"
        styleClass="p-button-outlined p-button-secondary mr-2"
        (click)="closeModal()"
      ></p-button>
      <p-button
        icon="pi pi-save"
        label="Save"
        [loading]="loading"
        [disabled]="!addressForm.valid || pincodeDetailsLoading"
        (click)="submitForm()"
      ></p-button>
    </div>
  </form>
</p-card>
